<template>
  <v-badge
    v-if="visible"
    bordered
    left
    :color="color"
    :content="content"
    overlap
  >
    <slot />
  </v-badge>
  <div v-else>
    <slot />
  </div>
</template>
<script lang="ts">
import Vue from 'vue';

export default Vue.extend({
  name: 'HideableBadge',
  props: {
    visible: { type: Boolean, required: false, default: true },
    content: { type: String, required: false, default: '' },
    color: { type: String, required: false, default: 'primary' },
  },
  data() {
    return {};
  },
  computed: { },
  methods: { },
});

</script>
